import React from "react";

/**
 * WorkOrderCardSkeleton
 *
 * Loading skeleton for WorkOrderCard component.
 */
export const WorkOrderCardSkeleton = (): JSX.Element => {
  return (
    <div className="relative flex flex-col sm:flex-row items-start sm:items-center gap-lg sm:gap-2xl p-md sm:p-lg rounded-lg border border-solid border-primary bg-primary animate-pulse">
      {/* Main content row */}
      <div className="flex items-center gap-md sm:gap-lg flex-1 min-w-0 w-full">
        {/* Icon skeleton */}
        <div className="w-5xl h-5xl rounded-full bg-accent flex-shrink-0" />

        {/* Title & info skeleton */}
        <div className="flex flex-col gap-xs sm:gap-sm flex-1 min-w-0">
          <div className="h-xl bg-accent rounded w-2/5" />
          <div className="h-md bg-accent rounded w-1/3" />
        </div>

        {/* Desktop Assignee skeleton */}
        <div className="hidden lg:flex -space-x-xs flex-shrink-0">
          <div className="w-xl h-xl rounded-full bg-accent border-2 border-solid border-primary" />
        </div>
      </div>

      {/* Tags & Mobile Assignees Row */}
      <div className="flex items-center justify-between gap-sm w-full sm:w-auto sm:flex-shrink-0 lg:gap-md">
        {/* Mobile/Tablet Assignee skeleton */}
        <div className="lg:hidden flex -space-x-xs flex-shrink-0">
          <div className="w-xl h-xl rounded-full bg-accent border-2 border-solid border-primary" />
        </div>

        {/* Tags skeleton group */}
        <div className="flex items-center gap-sm flex-wrap lg:flex-nowrap ml-auto lg:ml-0">
          <div className="h-xl w-16xl bg-accent rounded" />
          <div className="h-xl w-16xl bg-accent rounded" />
          <div className="h-xl w-12xl bg-accent rounded" />
        </div>
      </div>
    </div>
  );
};
